import { render, staticRenderFns } from "./VerifyEmailAddressWithCode.vue?vue&type=template&id=79d8806c&scoped=true"
import script from "./VerifyEmailAddressWithCode.vue?vue&type=script&lang=js"
export * from "./VerifyEmailAddressWithCode.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailAddressWithCode.vue?vue&type=style&index=0&id=79d8806c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d8806c",
  null
  
)

export default component.exports